import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./CancelDialog.css";

const CancelDialog = ({
  openCancelDialog,
  setOpenCancelDialog,
  dialogActionHandler,
  cancelDialogTitle,
  cancelDialogSubtitle
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={openCancelDialog}
      onClose={() => setOpenCancelDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom_cancel_dialog"
      PaperProps={{
        sx: {borderRadius: '30px', maxHeight: window.innerWidth < 480 ? '220px' : '260px', maxWidth: '400px', height: '100%'}
      }}
      sx={{
        width: '100%',
        height: '100%',
        textAlign: 'center'
      }}
    >
      <h3 className="cancel_dialog_title">
        {cancelDialogTitle}
      </h3>
      <h5 className="cancel_dialog_subtitle">
        {cancelDialogSubtitle}
      </h5>

        
      <DialogActions sx={{ marginBottom: '20px', justifyContent: "center", gap: '10px' }}>
        <Button
            className="dialog_cancel_btn"
            onClick={() => setOpenCancelDialog(false)}
            variant="contained"
            sx={{ 
              borderRadius: '100px', 
              backgroundColor: '#3232321a', 
              fontWeight: '600', 
              fontSize: '18px', 
              width: '100px',
              boxShadow: 'none',
              ":hover": {
                backgroundColor: '#3232321a',
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
              },
            }}
            >
            <span style={{color: '#000'}}>{t("no")}</span>
            </Button>
            <Button
            className="dialog_back_btn"
            onClick={dialogActionHandler}
            autoFocus
            variant="contained"
            sx={{ 
              borderRadius: '100px', 
              backgroundColor: '#06c0671a', 
              ":hover": {
                backgroundColor: '#06c0671a',
                boxShadow: 'unset'
              },
              boxShadow: 'none',
              fontSize: '18px',
              width: '100px',
              fontWeight: '600' }}
            >
                <span style={{color: '#06C067'}}>{t("yes")}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
         